import React from "react";
import PropTypes from "prop-types";

import {
    Row,
    Col,
    Modal,
    Card,
    Icon,
    Button,
    InputNumber,
    DatePicker,
    // Spin
} from "antd";
import moment from "moment";
import { formatCurrency } from "utilities";
import { Table } from "components";
// import { STATE_STATUS } from "constants";
import { REPAYMENT_INVOICE_COLS } from "constants/table-columns";
import { List } from "immutable";

// const { FETCHING, UNFETCHED } = STATE_STATUS;

class CashbackModal extends React.Component {
    state = {
        modalVisible: false,
        calculating: false,
        cashback: null
    };

    // componentDidMount() {

    // }

    // calculateCashback = async () => {
    //     const { amount, date } = this.state;
    //     this.setState({
    //         calculating: true
    //     });

    //     let _ = await FacilityService.getCashback(
    //         this.props.facilityId,
    //         amount,
    //         date.format("YYYY-MM-DD")
    //     );
    //     this.setState({
    //         cashback: _.data.cashback
    //     });
    // };
    render() {
        const { cashback } = this.state;
        return (
            <React.Fragment>
                <a
                    key="cashback"
                    href="javascript:void(0)"
                    onClick={() =>
                        this.setState({
                            modalVisible: true
                        })
                    }>
                    <Icon type="thunderbolt" /> Cashback
                </a>
                <Modal
                    title="Cashback Calculator"
                    visible={this.state.modalVisible}
                    closable
                    onCancel={() =>
                        this.setState({
                            modalVisible: false
                        })
                    }
                    footer={null}>
                    <div>
                        <div className={"d-flex"}>
                            <InputNumber
                                placeholder={"Amount to paid"}
                                style={{ marginRight: "10px", width: "200px" }}
                                onChange={amount => this.setState({ amount })}
                                disabled={this.calculating}
                            />
                            <DatePicker
                                placeholder={"DD-MM-YYY"}
                                style={{ marginRight: "10px" }}
                                onChange={date => this.setState({ date })}
                                disabled={this.calculating}
                            />
                            <Button
                                type={"default"}
                                style={{ marginRight: "10px" }}
                                onClick={this.calculateCashback}
                                disabled={this.calculating}>
                                Calculate
                            </Button>
                        </div>
                        <div className={"d-flex"} style={{ marginTop: "15px" }}>
                            {cashback !== null ? (
                                <h3 style={{ color: "#1890ff" }}>
                                    Cashback : {formatCurrency(cashback)}
                                </h3>
                            ) : null}
                        </div>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}

CashbackModal.propTypes = {
    facilityId: PropTypes.string
};

class RepaymentPlanList extends React.Component {
    state = {
        cashbackModalVisible: false,
        currentPage: 1,
        totalAmount: 0,
        totalCashbackRecieve: 0,
        totalInterestSave: 0
    };

    // componentWillMount() {
    //     const { repaymentPlans, facilityId, fetchRepaymentPlan } = this.props;
    //     const status = repaymentPlans.getIn([facilityId, "status"]);
    //     if (!status || status === UNFETCHED) {
    //         fetchRepaymentPlan(facilityId);
    //     }
    // }

    calculateCashback = () => {};
    toggleCashbackModal = () => {
        this.setState({
            cashbackModalVisible: !this.state.cashbackModalVisible
        });
    };
    renderPanelHeader = plan => {
        return (
            <div
                className={"d-flex justify-content-space-between"}
                style={{ paddingRight: "10px" }}>
                <div>
                    {plan.repayment_date === "Date"
                        ? plan.repayment_date
                        : moment(plan.repayment_date).format("DD/MM/YYYY")}
                </div>
                <div>
                    <span
                        style={{
                            display: "inline-block",
                            minWidth: "100px",
                            textAlign: "center"
                        }}>
                        {plan.repayment_amount === "Amount"
                            ? plan.repayment_amount
                            : formatCurrency(plan.repayment_amount)}
                    </span>
                    &nbsp; | &nbsp;
                    <span
                        style={{
                            display: "inline-block",
                            minWidth: "100px",
                            textAlign: "center"
                        }}>
                        {plan.buyer_cashback === "Cashback"
                            ? plan.buyer_cashback
                            : formatCurrency(
                                plan.buyer_cashback < 0
                                    ? 4.36
                                    : plan.buyer_cashback
                            )}
                    </span>
                </div>
            </div>
        );
    };

    getSelectedRows = (val) => {
        let selectedRows = val.toArray();
        const selectedInvoices = this.props.invoices.filter(_ => selectedRows.includes(_.id));
        this.setState({
            totalAmount: selectedInvoices.reduce(
                (agg, _) => agg + +_.invoice_amount,
                0
            ),
            totalCashbackRecieve: selectedInvoices.reduce(
                (agg, _) => agg + +_.cashback_as_of_today,
                0
            ),
            totalInterestSave: selectedInvoices.reduce(
                (agg, _) => agg + +_.interest_save_as_of_today,
                0
            )
        });
    }

    onPageChange = (page, pageSize) => {
        this.setState(
            {
                currentPage: String(page)
            },
            () => {
                if (this.pages.includes(this.state.currentPage)) {
                    return;
                }
                this.pages.push(this.state.currentPage);
                this.pageSize = pageSize;
                this.props.fetchOpenInvoices("Open", this.state.currentPage, this.pageSize);
            }
        );
    };

    onPageSizeChange = (page, pageSize) => {
        this.setState(
            {
                currentPage: String(page)
            },
            () => {
                this.pages = [page];
                this.pageSize = pageSize;
                this.props.fetchOpenInvoices("Open", this.state.currentPage, this.pageSize);
            }
        );
    };

    render() {
        return (
            <Card
                title={"Repayment Plan"}
                className={"padless-card"}
                extra={
                    (
                        <div className={"d-flex flex-row"}>
                            <div
                                className={
                                    "justify-content-space-between mb-5 px-5"
                                }>
                                <div style={{
                                    fontWeight: "bold"
                                }}> Amount </div>
                                <div>
                                    {" "}
                                    {formatCurrency(
                                        this.state.totalAmount
                                    )}
                                </div>
                            </div>
                            <div
                                className={
                                    "justify-content-space-between mb-5 px-5"
                                }>
                                <div style={{
                                    fontWeight: "bold"
                                }}> Buyer Cashback </div>
                                <div>
                                    {" "}
                                    {formatCurrency(
                                        this.state.totalCashbackRecieve
                                    )}
                                </div>
                            </div>
                            <div
                                className={
                                    "justify-content-space-between mb-5 px-5"
                                }>
                                <div style={{
                                    fontWeight: "bold"
                                }}> Interest Save </div>
                                <div>
                                    {" "}
                                    {formatCurrency(
                                        this.state.totalInterestSave
                                    )}
                                </div>
                            </div>
                        </div>
                    )
                }
            >
                {" "}
                <div
                    style={{
                        height: "auto"
                    }}>
                    <Row>
                        <Col span={24} className={"p-5"}>
                            <Table
                                columns={REPAYMENT_INVOICE_COLS}
                                data={this.props.invoices && this.props.invoices.toList() || new List([])}
                                showFooter={false}
                                keyFilter={"id"}
                                showColumnSelector={false}
                                pagination={false}
                                tablePagination={true}
                                showFilters={false}
                                onRowSelection={this.getSelectedRows}
                            />
                        </Col>
                    </Row>
                </div>
            </Card>
        );
    }
}

RepaymentPlanList.propTypes = {
    op_date: PropTypes.string,
    repaymentPlans: PropTypes.object,
    facilityId: PropTypes.string,
    fetchRepaymentPlan: PropTypes.func,
    invoices: PropTypes.array,
    poolAmount: PropTypes.number,
    adjustmentAdd: PropTypes.bool,
    sellerId: PropTypes.string,
    productName: PropTypes.string,
    repaymentDestinationValue: PropTypes.number,
    updateFacility: PropTypes.func,
    openInvoicesCount: PropTypes.number,
    fetchOpenInvoices: PropTypes.func
};

export default RepaymentPlanList;
